/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'i18n!../../dashboard/nls/DashboardResources',
	'i18n!./DashboardResources',
	'polyglot'
], function (titanResources, geminiResources, Polyglot) {

	const titanPoly = new Polyglot({
		phrases: titanResources,
		allowMissing: true
	});

	const geminiPoly = new Polyglot({
		phrases: geminiResources
	});

	class StringResources {
		/**
		 * Get the string resource for the given key and interpolation options
		 *
		 * @param {string} key The key of the string to return
		 * @param {object} [interpolationOptions] see poly.t documentation for details
		 * @returns {string} The corresponding string for the given key
		 */
		get(key, interpolationOptions) {
			let msg = titanPoly.t(key, interpolationOptions);
			if(msg === key) {
				msg = geminiPoly.t(key, interpolationOptions);
			}
			return msg;
		}
	};

	return new StringResources();
});
